import { render, staticRenderFns } from "./review-item.vue?vue&type=template&id=9472c0ce&scoped=true"
import script from "./review-item.vue?vue&type=script&lang=js"
export * from "./review-item.vue?vue&type=script&lang=js"
import style0 from "./review-item.vue?vue&type=style&index=0&id=9472c0ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9472c0ce",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadingBar: require('/app/components/global/loadingBar.vue').default})
